module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Export\n          ")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.bookPageId == '0' ? true : false,
      "variant": _vm.bookPageId == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('BOOK')
      }
    }
  }, [_vm._v("Booking")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.execPageId == '0' ? true : false,
      "variant": _vm.execPageId == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('EXEC')
      }
    }
  }, [_vm._v("Execution")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.vgmPageId == '1' || _vm.vgmBy == 'SHIPPER' ? true : false,
      "variant": _vm.vgmPageId == '1' || _vm.vgmBy == 'SHIPPER' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('VGM')
      }
    }
  }, [_vm._v("VGM")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.handoverPageId == '0' ? true : false,
      "variant": _vm.handoverPageId == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('HAND')
      }
    }
  }, [_vm._v("Handover & Rail-Out")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.sailPageId == '0' ? true : false,
      "variant": _vm.sailPageId == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('SAIL')
      }
    }
  }, [_vm._v("Sail & FPOD")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.ladingPageId == '0' ? true : false,
      "variant": _vm.ladingPageId == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('LADING')
      }
    }
  }, [_vm._v("Bill Of Lading")])], 1)], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.allModuleId > 0) ? _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.ffExoprtDetail.allModuleId ? this.ffExoprtDetail.allModuleId : '',
      "jobSeriesBanner": this.ffExoprtDetail.ffExportFclSeries ?
        this.ffExoprtDetail.ffExportFclSeries :
        '',
      "bannerClientName": _vm.getCLientData.length > 0 ? _vm.getCLientData[0].clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship",
      "prbr_id": _vm.ffExoprtDetail.prbr_id
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('StatusAlerts', {
    attrs: {
      "SUBS_alerts": _vm.SUBSAlerts
    }
  }), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            Status Verbose : " + _vm._s(_vm.ffExoprtDetail.status_verbose) + "\n          ")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            Event MSG : " + _vm._s(_vm.ffExoprtDetail.sub_noti_event_message) + "\n          ")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Container Load"
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("Stuffing Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.stuffingTypeList,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingType", $$v)
      },
      expression: "ffExoprtDetail.stuffingType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.stuffingType))]) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.containerInfo == 'fcl') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shippingIdError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Shipper Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Shipper Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientId", $$v)
      },
      expression: "ffExoprtDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.clientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Source Of Booking")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.shipTypeList,
      "option-value": "shipTypeVal",
      "option-text": "shipTypeText",
      "placeholder": "Select Source Of Booking "
    },
    model: {
      value: (_vm.ffExoprtDetail.shipType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shipType", $$v)
      },
      expression: "ffExoprtDetail.shipType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.containerInfo == 'lcl') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("CoLoader Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.getColoaderName,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Coloader Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.coloaderName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "coloaderName", $$v)
      },
      expression: "ffExoprtDetail.coloaderName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.shipType != '') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Booking Party")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Booking Party"
    },
    model: {
      value: (_vm.ffExoprtDetail.sourceOriginclientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "sourceOriginclientId", $$v)
      },
      expression: "ffExoprtDetail.sourceOriginclientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipType == 'Destination') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.getagentName,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "agentName", $$v)
      },
      expression: "ffExoprtDetail.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipType == 'Destination') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Buyer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "buyer",
      "name": "buyer"
    },
    model: {
      value: (_vm.ffExoprtDetail.buyer),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "buyer", $$v)
      },
      expression: "ffExoprtDetail.buyer"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.newJobType.indexOf('CC') >= 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccType", $$v)
      },
      expression: "ffExoprtDetail.ccType"
    }
  })], 1), _vm._v(" "), (_vm.ffExoprtDetail.ccType == 'Outsourced') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccCha", $$v)
      },
      expression: "ffExoprtDetail.ccCha"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Commodity Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "disabledCommodity": "",
      "Type": "",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityRemarks),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityRemarks", $$v)
      },
      expression: "ffExoprtDetail.commodityRemarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("HSN-Commodity Code *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemHSNCode",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityId", $$v)
      },
      expression: "ffExoprtDetail.commodityId"
    }
  }), (!_vm.ffExoprtDetail.commodityId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExportCommodityerrorList.commodityId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2 justify-content-end",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openCommodityModal()
      }
    }
  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Reefer') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ffExoprtDetail.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "temperatureRequired", $$v)
      },
      expression: "ffExoprtDetail.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Icd', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Icd', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PORlocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name",
      "isError": _vm.ffExoprtDetail.portType == 'Icd' ? false : true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.LPlocationId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PODLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.finalPlaceLocationId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.portType == 'Icd') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "pdaDetail"
    }
  }, [_vm._v("PDA Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.pdaDetailList,
      "option-value": "pdaDetailsVal",
      "option-text": "pdaDetailsText",
      "placeholder": "Select PDA "
    },
    model: {
      value: (_vm.ffExoprtDetail.pdaDetail),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pdaDetail", $$v)
      },
      expression: "ffExoprtDetail.pdaDetail"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryMode", $$v)
      },
      expression: "ffExoprtDetail.deliveryMode"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryTerms", $$v)
      },
      expression: "ffExoprtDetail.deliveryTerms"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Time At Origin(In Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "freeTimeAtOrigin",
      "name": "freeTimeAtOrigin"
    },
    model: {
      value: (_vm.ffExoprtDetail.freeTimeAtOrigin),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "freeTimeAtOrigin", $$v)
      },
      expression: "ffExoprtDetail.freeTimeAtOrigin"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Time At Destination(In Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "freeTimeAtDestination",
      "name": "freeTimeAtDestination"
    },
    model: {
      value: (_vm.ffExoprtDetail.freeTimeAtDestination),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "freeTimeAtDestination", $$v)
      },
      expression: "ffExoprtDetail.freeTimeAtDestination"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.specialInstruction != null && _vm.specialInstruction != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Special Instruction")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.specialInstruction),
      callback: function($$v) {
        _vm.specialInstruction = $$v
      },
      expression: "specialInstruction"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 pl-2 pr-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Additional Task")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showOtherServiceArray), function(otherServiceNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "25"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "disabled": _vm.viewPagePref == 1,
        "md-value": otherServiceNameArray.value,
        "name": 'otherServices' + (index + 1),
        "id": 'otherServices' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.otherServiceNameArraySelect(otherServiceNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.otherServices[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.otherServices, index, $$v)
        },
        expression: "ffExoprtDetail.otherServices[index]"
      }
    }, [_vm._v(_vm._s(otherServiceNameArray.show))])], 1)
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffExoprtDetail.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remark", $$v)
      },
      expression: "ffExoprtDetail.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderS"
    },
    on: {
      "click": _vm.addFFExport
    }
  }, [_vm._v("Save & Proceed to Booking")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderS"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExoprtDetail.FFExportCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffExoprtDetail.FFExportCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExoprtDetail.FFExportUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffExoprtDetail.FFExportUpdated))])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Commodity-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Commodity"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName"
    },
    model: {
      value: (_vm.commodityModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "itemName", $$v)
      },
      expression: "commodityModal.itemName"
    }
  }), _vm._v(" "), (!_vm.commodityModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.itemName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("HSN Code "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "hsnCode",
      "name": "hsnCode"
    },
    model: {
      value: (_vm.commodityModal.hsnCode),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "hsnCode", $$v)
      },
      expression: "commodityModal.hsnCode"
    }
  }), _vm._v(" "), (!_vm.commodityModal.hsnCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.hsnCode))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addCommodity
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideCommodityModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "delete",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.deleteCon
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop11212",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose11212
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38773ae4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newFFExportFcl.vue
// module id = 2525
// module chunks = 0